export default __webpack_public_path__ + "static/tour-form1-b6b8ddba2057b45cf16508ba331191b8.jpg";